// extracted by mini-css-extract-plugin
export default {"container":"UserFilter_container__t2TiS","title":"UserFilter_title__wLlzq","subTitle":"UserFilter_subTitle__8j6Lh","noAssigneeSelected":"UserFilter_noAssigneeSelected__3dW6F"};